import ProductPageContent from "components/ProductPageContent";
import { PRODUCT_PAGES } from "data/productPages";

function VolcanicRockPage() {
  return <ProductPageContent data={PRODUCT_PAGES["volcanic-rock"]} />;
}

export default VolcanicRockPage;
